import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils/index';

export default generateWithAsyncActions(alt, [], [
    'searchActive',
    'mobileNavActive',
    'mobileActiveLinkIndex',
    'egNavActive',
    'tabletNavActive',
    'mobileLocaleActive',
    'mobileUserActive',
    'mobileNavActiveLinks',
    'closeMobileTablet',
    'euCookieMessageClose',
    'alertActive',
    'setEuCookieAccepted',
    'CTAclick'
]);



// WEBPACK FOOTER //
// ./app/scripts/actions/NavActions.js